export enum Web3Type {
  'EVM' = 'EVM',
  'SOL' = 'SOL',
  'BTC' = 'BTC',
  'SUI' = 'SUI',
  'TON' = 'TON',
  'ALL' = 'ALL',
}
